/**
 * @generated SignedSource<<7595326ac76ec2f42ef2f4b0014d0c65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddOrUpdateSiteTargetGroupsInput = {
  siteId: string;
  targetGroupIds: ReadonlyArray<string>;
};
export type SitesUpdateSiteTargetGroupsMutation$variables = {
  input: ReadonlyArray<AddOrUpdateSiteTargetGroupsInput>;
};
export type SitesUpdateSiteTargetGroupsMutation$data = {
  readonly addOrUpdateSiteTargetGroups: {
    readonly siteTargetGroupNode: ReadonlyArray<{
      readonly site: {
        readonly id: string;
      } | null | undefined;
      readonly targetGroup: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    }> | null | undefined;
  };
};
export type SitesUpdateSiteTargetGroupsMutation = {
  response: SitesUpdateSiteTargetGroupsMutation$data;
  variables: SitesUpdateSiteTargetGroupsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "siteTargetGroups",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "site",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetGroupNode",
  "kind": "LinkedField",
  "name": "targetGroup",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SitesUpdateSiteTargetGroupsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddOrUpdateSiteTargetGroupsPayload",
        "kind": "LinkedField",
        "name": "addOrUpdateSiteTargetGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteTargetGroupNode",
            "kind": "LinkedField",
            "name": "siteTargetGroupNode",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SitesUpdateSiteTargetGroupsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddOrUpdateSiteTargetGroupsPayload",
        "kind": "LinkedField",
        "name": "addOrUpdateSiteTargetGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteTargetGroupNode",
            "kind": "LinkedField",
            "name": "siteTargetGroupNode",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a573da6a92503be99a2224ba24ef768d",
    "id": null,
    "metadata": {},
    "name": "SitesUpdateSiteTargetGroupsMutation",
    "operationKind": "mutation",
    "text": "mutation SitesUpdateSiteTargetGroupsMutation(\n  $input: [AddOrUpdateSiteTargetGroupsInput!]!\n) {\n  addOrUpdateSiteTargetGroups(siteTargetGroups: $input) {\n    siteTargetGroupNode {\n      site {\n        id\n      }\n      targetGroup {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c763e60650985e58bb8ab57ccf9e8b14";

export default node;
